<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm d-flex justify-content-between catalogo-text"
          >
            Historial de salidas
            <router-link
              :to="{ name: 'NuevoSalida',  params: {

                        config: {
                          page: page,
                          dates: selectedDate,
                          almacen: almacen
                          }
                      } }"
            >
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-pencil" />Registrar salida
              </CButton>
            </router-link>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol md="6" lg="6" xl="4">
                <label class="d-block">Periodo:</label>
                <DateSelector
                  class="z-custom-2"
                  v-model="selectedDate"
                  :date="selectedDate"
                  @input="dateSelection()"
                />
              </CCol>
              <CCol md="6" lg="6" xl="8">
                <CRow>
                  <CCol md="12" lg="12">
                    <label>Almacén:</label>
                    <v-select
                      v-model="almacen"
                      :options="almacenes"
                      @input="filterLotes()"
                      :loading="isLoading"
                      class="margin-multi"
                      placeholder="Selecciona un almacén"
                    >
                      <template #open-indicator="{ attributes }">
                        <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                      </template>
                      <template #no-options>Sin resultados.</template>
                    </v-select>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>

            <CDataTable
              hover
              bordered
              responsive
              :loading="isLoading"
              :items="this.items"
              :fields="fields"
              :items-per-page="Number(50)"
              :noItemsView="noItems"
            >
              <template #over-table>
                <CRow>
                  <CCol sm="11" col="10">
                    <CInput v-model="filter" @input="searchTimeOut()" placeholder="Búsqueda..." />
                  </CCol>
                  <CCol class="p-0" sm="1" col="2">
                    <CDropdown
                      placement="bottom-start"
                      add-menu-classes="pt-0"
                      color="primary"
                      :show.sync="dropdownCustom"
                    >
                      <template #toggler>
                        <CButton color="secondary">
                          <CIcon name="cil-settings" />
                        </CButton>
                      </template>

                      <template #default>
                        <div class="p-3 d-flex flex-column w-100">
                          <div class="mb-1">
                            <span>
                              <strong>Ver</strong>
                            </span>
                          </div>
                          <hr class="line mt-1 mb-3" />
                          <div class="d-flex align-items-center justify-content-between mb-2">
                            <label class="mr-2">Ubicaciones:</label>
                            <CSwitch
                              @update:checked="toggleUbicaciones()"
                              class="mx-1"
                              color="primary"
                              variant="3d"
                            />
                          </div>
                          <div class="d-flex align-items-center justify-content-between mb-2">
                            <label class="mr-2">Cancelados:</label>
                            <CSwitch
                              @update:checked="toggleShowCancel()"
                              class="mx-1"
                              color="primary"
                              variant="3d"
                            />
                          </div>
                          <div class="d-flex align-items-center justify-content-between mb-2">
                            <label class="mr-2">Autor:</label>
                            <CSwitch @update:checked="toggleMostrarAutor()" class="mx-1" color="primary" variant="3d" />
                          </div>
                        </div>
                      </template>
                    </CDropdown>
                  </CCol>
                </CRow>
              </template>
              <template #folio-header>
                <div class="d-flex flex-row">
                  <span class="align-self-center">Folio</span>
                  <OrderButtons :onClick="sortField" :field="'doc_salidas.folio'" :order="false" :fila="actualSort" :direcction="sorting"/>
                </div>
              </template>
              <template #fechahora-header>
                <div class="d-flex flex-row">
                  <span class="align-self-center">Fecha</span>
                  <OrderButtons :onClick="sortField" :field="'doc_salidas.payload->encabezado->fechahora'" :order="false" :fila="actualSort" :direcction="sorting"/>
                </div>
              </template>
              <template #almacen_id-header>
                <div class="d-flex flex-row">
                  <span class="align-self-center">Almacén</span>
                  <OrderButtons :onClick="sortField" :field="'almacen.payload->nombre'" :order="true" :fila="actualSortJoin" :direcction="sortingJoin"/>
                </div>
              </template>
              <template #folio="{item}">
                <td class="py-2">{{ item.folio }}</td>
              </template>

              <template #fechahora="{item}">
                <td class="py-2">{{ getDate(item.payload.encabezado.fechahora) }}</td>
              </template>
              <template #estado="{item}">
                <td class="py-2">{{ item.estado }}</td>
              </template>
              <template #almacen_id="{item}">
                <td class="py-2">{{ getAlmacen(item.payload.encabezado.almacen_id) }}</td>
              </template>
               <template #ubicaciones="{item}">
                <td class="py-2">{{ item.payload.encabezado._relaciones.ubicacion.map(m=>m.payload.nombre).join() }}</td>
              </template>
              <template #autor-header>
                <div class="d-flex flex-row">
                  <span v-show="mostrarColumnaAutor">Autor</span>
                </div>
              </template>
              <template #autor="{item}">
                <td class="py-2">
                  <span v-show="mostrarColumnaAutor">{{ item.author.correo }}</span>
                </td>
              </template>
              <template #ver="{item}">
                <td class="py-2">
                  <router-link
                    :to="{ name: 'VerSalida',
                    params: {
                      id: item.folio,
                      config: {
                        page: page,
                        dates: selectedDate,
                        almacen: almacen
                        } } }"
                  >
                    <CButton color="success" square size="sm">Ver</CButton>
                  </router-link>
                </td>
              </template>
              <template #cancel="{item, index}">
                <td class="py-2">
                  <CButton
                    color="danger"
                    square
                    size="sm"
                    @click="toggleCancel(index, item)"
                  >Cancelar</CButton>
                </td>
              </template>
              <template #reporte="{item, index}">
                <td class="py-2">
                  <CButton
                    color="info"
                    square
                    size="sm"
                    @click="getReporte(index, item)"
                  >
                  <i v-if="loader[index]" class="fa fa-spinner fa-pulse"></i>
                  <template v-else>PDF</template>
                  </CButton>
                </td>
              </template>
              <template #under-table>
                <CPagination
                  :activePage.sync="page"
                  :pages="pages"
                  align="center"
                  @update:activePage="e => actualizarInfo()"
                />
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      :show.sync="cancelModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Cancelar Salida"
      color="danger"
    >
      <h5 class="text-center">¿Deseas cancelar la salida con folio {{ this.itemModal.name }}?</h5>
      <template #header>
        <h5 class="modal-title">Cancelar Salida</h5>
        <CButtonClose @click="cancelModal = false" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="cancelModal = false" color="danger">Cancelar</CButton>
        <CButton @click="cancelDocto(itemModal.index, itemModal.id)" color="success">Aceptar</CButton>
      </template>
    </CModal>
    <CModal
      size="sm"
      title="Reporte"
      :centered="true"
      color="warning"
      :show.sync="warningModal"
    >{{ error }}</CModal>
  </div>
</template>

<script>
import DateSelector from "../../customComponents/DateSelector";
import vSelect from "vue-select";
import moment from "moment";
import "vue-select/dist/vue-select.css";
import OrderButtons from "../../customComponents/OrderButtons";
import GridAutorMixin from "../../mixins/GridAutor";


export default {
  name: "Salida",

  components: {
    DateSelector,
    vSelect,
    OrderButtons
  },
  mixins: [GridAutorMixin],
  data() {
    return {
      items: [],
      warningModal: false,
      error: "",
      config: this.$route.params.config,
      isCreated: false,
      isLoteActive: true,
      color1: "primary",
      color2: "secondary",
      cancelModal: false,
      dropdownCustom: false,
      showCancel: false,
      showUbicaciones: false,
      filter: "",
      almacen: null,
      almacenes: [],
      almacenesAll: [],
      itemModal: { id: "", name: "", index: "" },
      actualSort: "doc_salidas.payload->encabezado->fechahora",
      actualSortJoin: "",
      page: 1,
      pages: 1,
      sorting: "desc",
      sortingJoin: "",
      cambioUbicacionRaiz: false,
      sort: [
        {
          field: "doc_salidas.folio",
          isSorter: true
        },
        {
          field: "doc_salidas.payload->encabezado->fechahora",
          isSorter: true
        }
      ],
      noItems: { noResults: "Sin Resultados", noItems: "Sin Resultados" },
      isLoading: false,
      selectedDate: {
        start: moment()
          .startOf("month")
          .toDate(),

        end: moment()
          .endOf("month")
          .toDate()
      },
      loader:{},
    };
  },

  created() {
    if (this.ubicacionRaiz == "") {
      this.items = []
      this.almacenes = []
      return
    }
    this.isCreated = false;
    this.page = this.config ? this.config.page : 1;
    this.almacen = this.config && this.config.almacen;
    this.selectedDate = this.config ? this.config.dates : this.selectedDate;
    this.actualizarInfo();
  },

  computed: {
    fields(){
      return [
        { key: "folio", label: "Folio", _style: "width:10%" },
        // { key: "ubicacion", label: "Ubicación", _style: "width:10%" },
        { key: "fechahora", label: "Fecha", _style: "width:10%" },
        { key: "estado", label: "Estado", _style: "width:10%" },
        { key: "almacen_id", label: "Almacén", _style: "width:10%" },
        ...this.showUbicaciones?[{ key: "ubicaciones", label: "Ubicaciones", _style: "width:10%" }]:[],
        // {
        //   key: "UBICACION_NOMBRE",
        //   label: "Ubicación de Aplicación",
        //   _style: "width:10%"
        // },
        // { key: "producto", _style: "width:10%" },
        // { key: "unidad", label: "Unidad", _style: "width:10%" },
        // { key: "costo_unitario", _style: "width:10%" },
        // { key: "cantidad", _style: "width:10%" },
        // { key: "costo_total", _style: "width:10%" },
        {
          key: "autor",
          label: "",
          _style: "width:1%",
        },
        {
          key: "ver",
          label: "",
          _style: "width:1%",
          sorter: false,
          filter: false
        },
        {
          key: "reporte",
          label: "",
          _style: "width:1%",
          sorter: false,
          filter: false
        },
        {
          key: "cancel",
          label: "",
          _style: "width:1%",
          sorter: false,
          filter: false
        }
      ]
    },
    rangeStart() {
      return new Date(this.selectedDate.start).toLocaleDateString();
    },
    rangeEnd() {
      return new Date(this.selectedDate.end).toLocaleDateString();
    },
    filteredItems() {
      return this.items.filter(
        i =>
          i.folio
            .toString()
            .toLowerCase()
            .includes(this.filter.toLowerCase()) ||
          this.getDate(i.payload.encabezado.fechahora)
            .toLowerCase()
            .includes(this.filter.toLowerCase()) ||
          this.getAlmacen(i.payload.encabezado.almacen_id)
            .toLowerCase()
            .includes(this.filter.toLowerCase())
      );
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    }
  },

  watch: {
    items(newV,){
      this.loader = newV.reduce((v,c,i)=>({...v,[i]:false}),{})
    },
    ubicacionRaiz: function() {
      if (this.ubicacionRaiz == "") {
        this.items = []
        this.almacenes = []
        return
      }
      this.cambioUbicacionRaiz = true
      this.page = 1;
      this.actualizarInfo();
    }
  },

  methods: {
    getReporte(index,item){
      if(this.loader[index]){
        return
      }
      this.loader[index] = true
      this.$forceUpdate();
      const reportCall = {
        reporte: "formato_salidas",
        params: { folio:item.folio, ubicaciones: [this.ubicacionRaiz]},
        pdf : true
      };

      // console.log(reportCall);
      // call.push(reportCall);

      
        this.$store.dispatch("reportsPDFHttp", {
          ...reportCall
        }).then(res => {

          const blob = res;

          let a = document.createElement("a");
          a.style = "display: none";
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = "Reporte de salidas.pdf";
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch(rej => {
          // console.log(rej);
          this.error = rej.message;
          this.warningModal = true;
        })

        .finally(() => {
          this.loader[index] = false
          this.$forceUpdate();
        });
    },
    searchTimeOut() {
      if (this.isCreated) {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.timer = setTimeout(() => {
          // console.log("funciona");
          this.actualizarInfo();
        }, 800);
      }
    },
    toggleUbicaciones() {
      this.showUbicaciones = !this.showUbicaciones;
    },
    toggleShowCancel() {
      // console.log("entro");
      this.showCancel = !this.showCancel;
      this.actualizarInfo();
    },
    getDate(date) {
      
      return moment(date,'YYYY-MM-DD').format('DD/MM/YYYY');
    },
    getCultivo(cultivo_id) {
      const cultivoActual = this.cultivosAll.filter(
        cultivo => cultivo.id == cultivo_id
      );
      if (cultivoActual.length > 0) {
        return cultivoActual[0].payload.nombre;
      } else {
        return "";
      }
    },
    getUbicacion(ubicacion_id) {
      const ubicacionActual = this.ubicacionesAll.filter(
        ubicacion => ubicacion.id == ubicacion_id
      );
      if (ubicacionActual.length > 0) {
        return ubicacionActual[0].payload.nombre;
      } else {
        return "";
      }
    },
    getAlmacen(almacen_id) {
      const almacenActual = this.almacenesAll.find(
        almacen => almacen.id == almacen_id
      );

      return almacenActual ? almacenActual.payload.nombre : "";
    },
    sortField(field, direction, join) {
      if (join) {
        this.actualSort = ""
        this.sorting = ""
        this.actualSortJoin = field
        this.sortingJoin = direction
      }else{
        this.actualSort = field
        this.sorting = direction
        this.actualSortJoin = ""
        this.sortingJoin = ""
      }
      this.actualizarInfo();
    },
    getSorted(field) {
      const newSort = this.sort.find(item => item.field == field);
      if (newSort) {
        return newSort.isSorter;
      }
      return false;
    },
    dateSelection() {
      if (this.isCreated) {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.timer = setTimeout(() => {
          // console.log("funciona");
          this.actualizarInfo();
        }, 800);
      }
    },
    toggleEdit(index, item) {
      this.modal = true;
      const itemIndex = {
        id: index,
        name: item.cultivo
      };
      this.itemModal = itemIndex;
    },
    toggleCancel(index, item) {
      this.cancelModal = true;
      const itemIndex = {
        id: item.folio,
        name: item.folio,
        index: index
      };
      this.itemModal = itemIndex;
    },
    toggleLote() {
      this.isLoteActive = !this.isLoteActive;
      this.color1 = this.isLoteActive ? "primary" : "secondary";
      this.color2 = this.isLoteActive ? "secondary" : "primary";
    },

    filterLotes() {
      if (this.isCreated) {
        this.actualizarInfo();
      }
    },
    cancelDocto(index, id) {
      this.isLoading = true;
      this.$store
        .dispatch("customDocumentoCancelHTTP", {
          schema: "salidas",
          folio: id
        })
        .then(res => {
          console.log(res.data);
          // const index = this.items.findIndex(item => item.folio == id);
          // this.items[index].estado = "cancelado";
          this.actualizarInfo();
        })
        .catch(rej => {
          console.log(rej);
        })

        .finally(() => {
          this.isLoading = false;
          this.cancelModal = false;
        });
    },
    actualizarInfo(){
      if (this.ubicacionRaiz == "") {
        this.items = []
        return
      }

      this.isLoading = true;

      let template = {
        schema: "salidas",
        limit: 50,
        page: this.page,
        filter: {
          wherein: [{
            field: "doc_salidas.payload->encabezado->ubicacion_raiz_id",
            value: [this.ubicacionRaiz]
          }],
          where: [
            {
              field: "doc_salidas.payload->encabezado->fechahora",
              operator: ">=",
              value: moment(this.selectedDate.start).format("YYYY-MM-DD 00:00:00")
            },
            {
              field: "doc_salidas.payload->encabezado->fechahora",
              operator: "<=",
              value: moment(this.selectedDate.end).format("YYYY-MM-DD 23:59:59")
            }
          ]
        },
        ["with-storage"]: ["*"]
      };

      this.actualSort != "" ? (template = {
        ...template,
        order: [{
          field: this.actualSort,
          direction: this.sorting
        }]
      }) : null

      this.actualSortJoin != "" ? (template = {
        ...template,
        orderByJoin: [{
          field: this.actualSortJoin,
          direction: this.sortingJoin
        }]
      }) : null

      this.filter != "" ? (template = {
        ...template, filter: {
          ...template.filter,
          and: {
            orWhere: [
              {
                field: "doc_salidas.folio",
                operator: "like",
                value: `%${this.filter}%`,
                collate: "utf8mb4_unicode_ci"
              },
              ...this.mostrarColumnaAutor?[
              {
                field: "doc_salidas.author->correo",
                operator: "like",
                value: `%${this.filter}%`,
                collate: "utf8mb4_unicode_ci"
              },
              ]:[]
            ],
            orWhereJoin:[
              {
                field: "almacen.payload->nombre",
                operator: "like",
                value: `%${this.filter}%`,
                collate: "utf8mb4_unicode_ci"
              }
            ]
          }
        }
      }) : null;

      !this.showCancel ? (template = {
        ...template, filter: {
          ...template.filter,
          where: [
            ...template.filter.where,
            {
              field: "doc_salidas.estado",
              operator: "!=",
              value: "cancelado"
            }
          ]
        }
      }) : null;

      if (this.almacen) {
        template = {
          ...template,
          filter: {
            ...template.filter,
            where: [
              ...template.filter.where,
              {
                field: "doc_salidas.payload->encabezado->almacen_id",
                operator: "=",
                value: this.almacen.value
              }
            ]
          }
        };
      }

      const documento = [
        this.$store.dispatch("customDocumentoHTTP", template)
      ]

      if (!this.isCreated || this.cambioUbicacionRaiz) {
        this.cambioUbicacionRaiz = false
        documento.push(this.$store.dispatch("customHTTP", {
            schema: "almacenes",
            filter: {
              wherein: [
                {
                  field: "payload->ubicacion_id",
                  value: [this.ubicacionRaiz]
                }
              ]
            }
          })
        )
      }
      Promise.all(documento)
        .then(([documentos, almacenes]) => {
          this.items = documentos.data;
          if(almacenes){
            this.almacenes = almacenes.data.map(almacen => {
              return { value: almacen.id, label: almacen.payload.nombre };
            });
            this.almacenesAll = almacenes.data;
          }
          this.pages = documentos?.paginate?.last_page;
          this.page = documentos?.paginate?.current_page;

          this.isCreated = true;
        })
        .catch(rej => console.log(rej.message))
        .finally(() => (this.isLoading = false));


    }
  }
};
</script>

<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.z-custom {
  z-index: 1;
}
.z-custom-2 {
  z-index: 4;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  width: 100%;
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.padding-left-custom {
  padding-right: 5rem;
}
.custom-width-btn {
  width: 40%;
}
.custom-heigth-btn {
  width: 100%;
}
.custom-font-size {
  font-size: 1rem;
}
.margin-multi {
  margin-bottom: 1rem !important;
}
.cursor-p {
  cursor: pointer;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 12px;
  }
  .padding-sm {
    padding-left: 10px;
    padding-right: 10px;
  }
  .text-sm {
    font-size: 11px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
